var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgStopwatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 8.625L19.2308 7.59375C19.4712 7.35938 19.4712 7.03125 19.2308 6.79688L18.4135 6C18.1731 5.76562 17.8365 5.76562 17.5962 6L16.5865 6.98438C15.0962 5.67188 13.2212 4.82812 11.1538 4.59375V2.25H12.5C12.7885 2.25 13.0769 2.01562 13.0769 1.6875V0.5625C13.0769 0.28125 12.7885 0 12.5 0H7.5C7.16346 0 6.92308 0.28125 6.92308 0.5625V1.6875C6.92308 2.01562 7.16346 2.25 7.5 2.25H8.84615V4.59375C3.84615 5.15625 0 9.28125 0 14.25C0 19.6406 4.47115 24 10 24C15.4808 24 20 19.6406 20 14.25C20 12.1875 19.2788 10.2188 18.125 8.625ZM10 21.75C5.72115 21.75 2.30769 18.4219 2.30769 14.25C2.30769 10.125 5.72115 6.75 10 6.75C14.2308 6.75 17.6923 10.125 17.6923 14.25C17.6923 18.4219 14.2308 21.75 10 21.75ZM10.5769 16.5C10.8654 16.5 11.1538 16.2656 11.1538 15.9375V9.5625C11.1538 9.28125 10.8654 9 10.5769 9H9.42308C9.08654 9 8.84615 9.28125 8.84615 9.5625V15.9375C8.84615 16.2656 9.08654 16.5 9.42308 16.5H10.5769Z",
    fill: "#6A747F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgStopwatch);
export default __webpack_public_path__ + "static/media/img_stopwatch.7f79ea3bb7ce918ba0956b4bec0e744e.svg";
export { ForwardRef as ReactComponent };